export const getPostcodeFinderSuggestions = state => state.postcodeFinderReducer.suggestions;
export const getPostcodeFinderAddresses = state => state.postcodeFinderReducer.addresses;
export const getPostcodeFinderIsFetching = state => state.postcodeFinderReducer.isPosting;
export const getPostcodeFinderError = state => state.postcodeFinderReducer.error;
